import { render, staticRenderFns } from "./PhasesNavigateButtons.vue?vue&type=template&id=33798a17"
import script from "./PhasesNavigateButtons.vue?vue&type=script&lang=js"
export * from "./PhasesNavigateButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports